import i18n from 'dashboard/i18n/instance';

export const UNAUTHORIZED_API_ERROR = 'You are not authorized to do this action';

export const localizeUnauthorizedError = message => {
  if (message !== UNAUTHORIZED_API_ERROR) {
    return message;
  }

  return i18n.global.t('GENERAL.UNAUTHORIZED');
};
